import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const adminVerifiedService = {
  getAllPost,
  getPostStatus,
  getInstructor,
  deleteDraft,
  unApprovedPost
};

function getAllPost(params) {
  return apiCall("GET", `${apiUrls.posts.base}`, null, params);
}

function getPostStatus(params) {
  return apiCall("GET", `${apiUrls.posts.base}`, null, params);
}

function getInstructor(id) {
  return apiCall("GET", `${apiUrls.instructors.base}/${id}`);
}

function deleteDraft(id) {
  return apiCall("DELETE", `${apiUrls.posts.base}/${id}`);
}

function unApprovedPost(id) {
  return apiCall("PUT", `${apiUrls.posts.unApprovePost}/${id}`);
}
